'use client'

import services from '@/services'
import { useEffect, useState } from 'react'
import { STEPS } from '@/constants/steps'
import { useRouter } from 'next/navigation'
import { useForm } from 'react-hook-form'
import { getAnalyticsPayload } from '@/utils/analytics'
import { noticeError } from '@/utils/newRelic'
import storage from '@/utils/browser/storage'
import clarity from '@/utils/clarity'
import analytics from '@/utils/analytics'
import envs from '../../../envs'

import { SELECT_OPTION_MAPPER, SELECT_OPTIONS } from '@/constants/plans'

const useFormSoftlead = ({
  productId,
  planId,
  isFormWithSelect,
  isSubscriberFlow
}) => {
  const [productIdSubmit, setProductIdSubmit] = useState(productId)
  const [isLoading, setIsLoading] = useState(false)
  const router = useRouter()

  const {
    handleSubmit,
    control,
    clearErrors,
    setValue,
    formState: { isValid },
    watch
  } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      name: '',
      email: '',
      phone: '',
      productType: ''
    }
  })
  const selectField = watch('productType')

  const onSubmit = async (data) => {
    analytics.setup({
      shortUrls: ['saiba-mais', 'lapa-team'],
      tracrConfig: {
        clientId: envs?.TRACR_CLIENT_ID,
        appKey: envs?.TRACR_APP_KEY,
        environment: envs?.ENVIRONMENT_ID
      }
    })

    const analyticsPayload = await getAnalyticsPayload()

    const payload = {
      additionalData: {
        ...analyticsPayload
      },
      name: data.name,
      email: data.email,
      phone: data.phone.replace(/\D/g, ''),
      productId: productIdSubmit
    }

    if (planId) {
      payload.planId = planId
      sessionStorage.setItem('planIdSelected', planId)
    }

    setIsLoading(true)
    try {
      const response = await services.leads.post({ body: payload })

      clarity.setUpgrade('Lead created')

      clarity.setTags([
        {
          name: 'product_id',
          value: productIdSubmit
        },
        {
          name: 'lead_uuid',
          value: response?.lead_uuid
        }
      ])

      if (!analyticsPayload.source_url) {
        noticeError(`sourceUrl not found in softlead: ${analytics.source_url}`)
      }

      const redirectUrl = isSubscriberFlow
        ? `${STEPS[response?.navigation?.next]}?assinatura=${productIdSubmit}`
        : STEPS[response?.navigation?.next]
      router.push(redirectUrl)
    } catch (err) {
      console.error(err)
      setIsLoading(false)
    }
  }

  const updateProductId = (isUpdateFromSelect = false) => {
    if (!isFormWithSelect) return

    if (isUpdateFromSelect) {
      setProductIdSubmit(SELECT_OPTION_MAPPER[selectField])
      return
    }

    SELECT_OPTIONS.map((option) => {
      if (option?.productId === productId) {
        setValue('productType', option?.value)
      }
    })

    setProductIdSubmit(SELECT_OPTION_MAPPER[productId])
  }

  useEffect(() => {
    const leadInfo = storage.session.getItem('lead')
    if (leadInfo) {
      setValue('name', leadInfo?.name || '')
      setValue('email', leadInfo?.email || '')
      setValue('phone', `+${leadInfo?.phone}` || '+55')
    }

    isFormWithSelect ? setValue('productType', 'Aulas Ao Vivo + Gravadas') : ''
  }, [])

  useEffect(() => {
    updateProductId(true)
  }, [selectField])

  useEffect(() => {
    updateProductId()
  }, [productId])

  return {
    control,
    handleSubmit,
    onSubmit,
    clearErrors,
    isValid,
    isLoading
  }
}

export default useFormSoftlead
